import React from "react";

export default function ContactOptions() {
  return (
    <section className="bg-gray-50 dark:bg-gray-900 p-6 rounded-lg shadow-md max-w-xl mx-auto">
      <h3 className="text-2xl font-semibold mb-6 text-gray-900 dark:text-white">
        Contact Us
      </h3>
      <ul className="space-y-4 text-gray-700 dark:text-gray-300 text-lg">
        <li className="flex items-center space-x-3">
          <span className="font-semibold w-20">Email:</span>
          <a
            href="mailto:support@ngcfinancial.com"
            className="text-blue-600 hover:underline"
          >
            support@ngcfinancial.com
          </a>
        </li>
        <li className="flex items-center space-x-3">
          <span className="font-semibold w-20">Phone:</span>
          <a href="tel:+1234567890" className="text-blue-600 hover:underline">
            +1 (234) 567-890
          </a>
        </li>
        <li className="flex items-center space-x-3">
          <span className="font-semibold w-20">Live Chat:</span>
          <a href="/livechat" className="text-blue-600 hover:underline">
            Start Chat
          </a>
        </li>
      </ul>
    </section>
  );
}
